import React, { useState, useEffect } from "react";
import { Row, Col, Button } from 'react-bootstrap';
import { useDispatch } from 'redux-react-hook';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { ArrowRight } from 'react-bootstrap-icons';

export default function SettingGroup(props) {
    const questionIndex = props.index;
    const groupData = props.data || [];
    const [items, setItems] = useState([]);
    const [selected, setSelected] = useState([]);
    const dispatch = useDispatch();
    const grid = 8;
    const [isFetched, setIsFetched] = useState(false);

    useEffect(() => {
        console.log("!", groupData, props.ops);
        if (null != groupData
            && null != props.ops && props.ops.length > 0) {
            let tmpItems = [];
            let tmpSelected = [];
            props.ops.forEach((op, index) => {
                if (groupData.indexOf(index) >= 0) {
                    //已在選項中
                    tmpSelected.push({ id: "se-" + index, content: (index + 1) });
                } else {
                    //不在選項中
                    tmpItems.push({ id: "it-" + index, content: (index + 1) });
                }
            });
            console.log("!", tmpItems, tmpSelected);
            setItems(tmpItems);
            setSelected(tmpSelected);
        }
        setIsFetched(true);
    }, [isFetched]);


    function move(source, destination, droppableSource, droppableDestination) {
        const sourceClone = Array.from(source);
        const destClone = Array.from(destination);
        const [removed] = sourceClone.splice(droppableSource.index, 1);

        destClone.splice(droppableDestination.index, 0, removed);

        const result = {};
        result[droppableSource.droppableId] = sourceClone;
        result[droppableDestination.droppableId] = destClone;

        return result;
    }

    function reorder(list, startIndex, endIndex) {
        let tmp = list.sort((a, b) => {
            let aTmp = a.id,
                bTmp = b.id;
            if (aTmp == bTmp) return 0;
            if (aTmp > bTmp) return 1;
            return -1;
        });
        // console.log(tmp)
        return tmp;
    }

    function getItemStyle(isDragging, draggableStyle) {
        return ({
            // some basic styles to make the items look a bit nicer
            userSelect: "none",
            padding: grid * 2,
            margin: `0 0 ${grid}px 0`,
            border: `1px solid lightgray`,

            // change background colour if dragging
            background: isDragging ? "lightgreen" : "white",

            // styles we need to apply on draggables
            ...draggableStyle
        })
    }

    function getListStyle(isDraggingOver) {
        return ({
            background: isDraggingOver ? "#f0f0f0" : "white",
            padding: grid,
            width: '100%'
        });
    }

    function getList(id) {
        // id2List = {
        //     droppable: 'items',
        //     droppable2: 'selected'
        // };

        if (id == "droppable") return items;
        return selected;
        // this.state[this.id2List[id]];
    }

    function onDragEnd(result) {
        const { source, destination } = result;

        // dropped outside the list
        if (!destination) {
            return;
        }

        if (source.droppableId === destination.droppableId) {
            const tmp = reorder(
                getList(source.droppableId),
                source.index,
                destination.index
            );

            if (source.droppableId === 'droppable2') {
                setSelected(tmp);
            } else {
                setItems(tmp);
            }
        } else {
            const result = move(
                getList(source.droppableId),
                getList(destination.droppableId),
                source,
                destination
            );
            const tmpSelect = reorder(result.droppable2),
                tmpItems = reorder(result.droppable);

            setSelected(tmpSelect);
            setItems(tmpItems);
            let tmp = Object.keys(tmpSelect).map((key) => (tmpSelect[key].content - 1));
            dispatch({
                type: "QUESTION_SET_GROUP",
                index: questionIndex,
                data: tmp
            });
        }

    };

    function render() {
        return (
            <>
                <Row className="mt-3">
                    <Col>選項清單<ArrowRight className="ml-3" /></Col>
                    <Col>互斥項目</Col>
                </Row>
                <Row>
                    <Col className="text-muted"></Col>
                    <Col className="text-muted"><small>放入要與其他選項互斥的選項</small></Col>
                </Row>
                <DragDropContext onDragEnd={onDragEnd}>
                    <Row className="groupOpt-container">
                        <Col className="droppable">
                            <Droppable className="droppable" droppableId="droppable">
                                {(provided, snapshot) => (
                                    <div
                                        ref={provided.innerRef}
                                        style={getListStyle(snapshot.isDraggingOver)}>
                                        {items.map((item, index) => (
                                            <Draggable
                                                key={item.id}
                                                draggableId={item.id}
                                                index={index}>
                                                {(provided, snapshot) => (
                                                    <div
                                                        ref={provided.innerRef}
                                                        {...provided.draggableProps}
                                                        {...provided.dragHandleProps}
                                                        style={getItemStyle(
                                                            snapshot.isDragging,
                                                            provided.draggableProps.style
                                                        )}>
                                                        {item.content}
                                                    </div>
                                                )}
                                            </Draggable>
                                        ))}
                                        {provided.placeholder}
                                    </div>
                                )}
                            </Droppable>
                        </Col>
                        <Col className="droppable">
                            <Droppable droppableId="droppable2">
                                {(provided, snapshot) => (
                                    <div
                                        ref={provided.innerRef}
                                        style={getListStyle(snapshot.isDraggingOver)}>
                                        {selected.map((item, index) => (
                                            <Draggable
                                                key={item.id}
                                                draggableId={item.id}
                                                index={index}>
                                                {(provided, snapshot) => (
                                                    <div
                                                        ref={provided.innerRef}
                                                        {...provided.draggableProps}
                                                        {...provided.dragHandleProps}
                                                        style={getItemStyle(
                                                            snapshot.isDragging,
                                                            provided.draggableProps.style
                                                        )}>
                                                        {item.content}
                                                    </div>
                                                )}
                                            </Draggable>
                                        ))}
                                        {provided.placeholder}
                                    </div>
                                )}
                            </Droppable>
                        </Col>
                    </Row>
                </DragDropContext>
            </>
        );
    }

    return render();
}
